import { createApiClient } from '@mondy/shared/api-client';
import { getToken } from '@/lib/auth';

const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:3002';

export const api = createApiClient({
  baseUrl,
  getToken,
});
